import {
	ChangeDetectionStrategy,
	Component,
	computed,
	ContentChild,
	input,
	signal,
	TemplateRef,
} from '@angular/core';
import { FeaturedUndergraduate, FeaturedPostgraduate } from '@uc/web/shared/data-models';
import { Fees } from '../../models/course.models';
import { FeesAndFundingService } from './fees-and-funding.service';
import { SortAscendingSvgComponent, SortDescendingSvgComponent } from '@uc/shared/svg';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'uc-fees-and-funding',
	templateUrl: './fees-and-funding.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, SortDescendingSvgComponent, SortAscendingSvgComponent],
})
export class FeesAndFundingComponent {
	fees = input.required<Fees[]>();
	externalUrl = input.required<string>();
	isFeatured = input.required<FeaturedUndergraduate | FeaturedPostgraduate>();
	sortAscend = signal(true);
	currentYear = new Date().getFullYear();
	nextYearTrail = +String(new Date().getFullYear()).slice(2, 4) + 1;

	@ContentChild('visitWebsiteBtnFeesFunding') visitWebsiteBtnRef!: TemplateRef<any>;

	editedFees = computed(() =>
		this._feesSrv.editFeesAndFunding(this.fees(), this.sortAscend()),
	);

	constructor(private _feesSrv: FeesAndFundingService) {}

	onSortFees(sortAscend: boolean) {
		this.sortAscend.set(sortAscend);
	}
}
